import { AnnouncementsCard } from '@backstage-community/plugin-announcements';

export const EngineeringNewsCard = () => {
  return <AnnouncementsCard max={3} />;
};
